export default {
    ENVIRONMENT: import.meta.env.VITE_ENVIRONMENT,
    API_URL: import.meta.env.VITE_API_URL,
    AUTH_SERVICE: import.meta.env.VITE_AUTH_SERVICE,
    COMPOSER_FRONTEND_NEXT_API: import.meta.env.VITE_COMPOSER_FRONTEND_NEXT_API,
    AUTH_SERVICE_SIGNIN: import.meta.env.VITE_AUTH_SERVICE_SIGNIN,
    SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
    YOUTUBE_API_KEY: import.meta.env.VITE_YOUTUBE_API_KEY,
    AG_CHART_LICENSE_KEY: import.meta.env.VITE_AG_CHART_LICENSE_KEY,
    ENCODED_AG_CHART_LICENSE_KEY: import.meta.env
        .VITE_ENCODED_AG_CHART_LICENSE_KEY,
    FIGMA_PLUGIN_ID: import.meta.env.VITE_FIGMA_PLUGIN_ID,
    BASE_PATH: import.meta.env.VITE_BASE_PATH || '/',
};
